export type ExecutionStatus = 'pending' | 'running';

/* eslint-disable @typescript-eslint/naming-convention */
export interface IActiveExecutionRaw {
  run_id: string;
  status: ExecutionStatus;
  response_message_id: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface IActiveExecution {
  runId: string;
  status: ExecutionStatus;
  responseMessageId: string;
}

export const toActiveExecution = (raw: IActiveExecutionRaw): IActiveExecution => ({
  runId: raw.run_id,
  status: raw.status,
  responseMessageId: raw.response_message_id
});

export const toOptionalActiveExecution = (
  raw: IActiveExecutionRaw | null | undefined
): IActiveExecution | null => (raw ? toActiveExecution(raw) : null);
